import { createMuiTheme } from '@material-ui/core/styles';
import { indigo, orange } from '@material-ui/core/colors';

const defaultTheme = createMuiTheme({
  palette: {
    primary: indigo,
    secondary: orange,
  },
});

const theme = createMuiTheme({
  palette: {
    primary: indigo,
    secondary: orange,
  },
  typography: {
    fontFamily: '"Open Sans", sans-serif',
  },
  overrides: {
    MuiToolbar: {
      root: {
        color: defaultTheme.palette.common.black,
        backgroundColor: defaultTheme.palette.common.white,
        borderTop: `5px solid ${defaultTheme.palette.primary.main}`,
      },
    },
    MuiChip: {
      root: {
        borderRadius: '3px',
      },
    },
    MuiAppBar: {
      root: {
        boxShadow:
          '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
      },
    },
  },
});

export default theme;



// WEBPACK FOOTER //
// ./src/components/Theme.js